import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Form, Input, Row } from 'antd'
import { compose } from 'recompose'
import CustomSelect from '../../../elements/Select/CustomSelect'
import withUrlFetch from '../../../elements/Select/withUrlFetch'
import withSpinning from '../../../elements/HOC/withSpinning'
import withSort from '../../../elements/HOC/withSort'
import useFetchObject from '../../../elements/Hooks/useFetchObject'
import { extranet } from '../../../api/User'
import withLoadingSection from '../../../elements/HOC/withLoadingSection'
import { get, isEmpty } from 'lodash'
import { arrVal } from '../../../modules/Utils'
import useSubmit from '../../../elements/Hooks/useSubmit'

const ClientsSelect = compose(
  withUrlFetch({
    url: 'oauth/clients/',
    name: 'clients',
    forceFetch: true,
  }),
  withSpinning,
  withSort,
)(CustomSelect)
const ScopesSelects = compose(
  withUrlFetch({
    url: 'oauth/scopes/',
    name: 'scopes',
    forceFetch: true,
  }),
  withSpinning,
  withSort,
)(CustomSelect)

function Users (props) {
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 5 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 19 },
    },
  }
  const [userClient, setUserClient] = useState('')
  const { member } = props
  const { getFieldDecorator } = props.form
  const { object: user } = useFetchObject(() => extranet.getUser(member._key))
  const applicationsClient = user.scopes || []
  const defaultClient = get(user, 'scopes.0.client')
  const [submitted, submitting, submit] = useSubmit(() =>
    extranet.updateUser(member._key, [
      {
        scopes: props.form.getFieldValue('scopes'),
        _key: userClient,
      },
    ]),
  )

  function onChangeClient (key) {
    setUserClient(get(applicationsClient.find(a => a.client === key), '_key'))
    props.form.setFieldsValue({
      scopes: arrVal(applicationsClient.find(a => a.client === key), 'scopes'),
    })
  }

  useEffect(() => onChangeClient(defaultClient), [defaultClient])

  return (
    <Row>
      <Col span={4}/>
      <Col span={16}>
        <Card style={{ width: '100%' }} title={'Applications Management'}>
          <Form>
            <Row>
              <Col span={18}>
                <Form.Item label="Username" {...formItemLayout}>
                  {getFieldDecorator('user', {
                    initialValue: get(user, 'user.username'),
                    rules: [
                      {
                        required: true,
                        message: 'User can\'t be empty ',
                      },
                    ],
                  })(<Input disabled={!isEmpty(user)}/>)}
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={18}>
                <Form.Item label="Client" {...formItemLayout}>
                  {getFieldDecorator('client', {
                    initialValue: defaultClient,
                    rules: [
                      {
                        required: true,
                        message: 'Client can\'t be empty ',
                      },
                    ],
                  })(
                    <ClientsSelect
                      onChange={onChangeClient}
                      keyAtr={'_key'}
                      valueAtr={'name'}
                    />,
                  )}
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col span={18}>
                <Form.Item label="Scope" {...formItemLayout}>
                  {getFieldDecorator('scopes', {
                    rules: [
                      {
                        required: true,
                        message: 'Scope can\'t be empty ',
                      },
                    ],
                  })(
                    <ScopesSelects
                      mode="multiple"
                      keyAtr={'code'}
                      valueAtr={'name'}
                    />,
                  )}
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <Button
            loading={submitting}
            type={'primary'}
            style={{ float: 'right' }}
            onClick={submit}>
            Update
          </Button>
        </Card>
      </Col>
    </Row>
  )
}

Users.propTypes = {}
Users.defaultProps = {}

export default withLoadingSection(Form.create()((Users)))
